import './App.css';
import Navigates from './Navigates/Navigates';
import { ThemeProvider } from './theme/theme-provider';
import { Toaster } from './ui/sonner';

function App() {
    return (
        // UI-only theme context for the Phase 1 app shell. Defaults to light so
        // legacy antd/MUI screens are unaffected until a user opts into dark.
        <ThemeProvider defaultTheme="light">
            <Navigates/>
            {/* Phase 2: single unified toaster (replaces antd message / MUI Snackbar / notistack). */}
            <Toaster position="top-right" richColors closeButton />
        </ThemeProvider>
    );
}

export default App;
